export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.7.8-1602.16",
  commitId: "e075f4cdf09739b27bc5b6a93a3e3e0e26bbc07b",
  commitTime: "2026-07-08T16:02:16.000Z",
});
